import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";


class About extends Component {

  componentDidMount() {

  }

  render() {
    return (
      <div className={`main-content${wActs.MainLeftStyle(this.props.WebPage)} left`}>
        <SeoHeaders Position={"Top"}/>
        <pre  style={{fontSize: '14px', lineHeight: '14px'}} dangerouslySetInnerHTML={{__html: this.props.MainContent}}></pre>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(About);
